<template>
    <FloatLabel variant="on">
        <InputGroup>
            <AutoComplete
                v-model="accountNo"
                :suggestions="accountNos"
                :virtual-scroller-options="{ itemSize: 33 }"
                placeholder=""
                force-selection
                complete-on-focus
                fluid
                typeahead
                class="w-32"
                @complete="onSearch"
                @keydown.enter.prevent
            >
                <template #option="slotProps">
                    <div class="flex items-center gap-2">
                        <div class="font-bold">{{ slotProps.option }}</div>
                        <div>{{ accountFromAccountNo(slotProps.option)?.name }}</div>
                    </div>
                </template>
                <template #header>
                    <div class="w-96"/>
                </template>
            </AutoComplete>
        </InputGroup>
    </FloatLabel>
</template>

<script setup lang="ts">

import {bookkeepingAccounts} from '@/bookkeeping-account/bookkeepingAccount.service'
import {computed, ref} from 'vue'
import {AutoComplete, FloatLabel, InputGroup} from 'primevue'
import {BookkeepingAccount} from '@/bookkeeping-account/BookkeepingAccount'

const suggestions = ref<BookkeepingAccount[]>([])

const sortedSuggestions = computed<BookkeepingAccount[]>(() => {
    return [...suggestions.value].sort((a, b) => a.accountNo.localeCompare(b.accountNo))
})

const accountNos = computed(() => {
    return sortedSuggestions.value.map(account => account.accountNo)
})

const accountFromAccountNo = (accountNo: string) => {
    return bookkeepingAccounts.value.find(account => account.accountNo === accountNo) || null
}

const accountNo = defineModel({
    type: String,
    default: ''
})

const onSearch = (event: { query: string }) => {
    const searchValue = event.query.trim()
    if (searchValue.length === 0) {
        suggestions.value = bookkeepingAccounts.value
    }
    suggestions.value = bookkeepingAccounts.value.filter((account) => {
        return account.name.toLowerCase().includes(searchValue.toLowerCase())
            || account.accountNo.toLowerCase().includes(searchValue.toLowerCase())
    })
}

</script>

<style scoped>

</style>